module.exports = __webpack_public_path__ + "img/1443132547.24079cfd.jpg";